// @ts-nocheck
/* eslint-disable func-names */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/named */
import { takeLatest, spawn, put } from 'redux-saga/effects';

import apiRequest, { apiSuccess } from 'utils/api';
import { truthty } from 'utils/functions';
import { appActions } from 'commons/reducer';
import { FRUITS } from '../reducer';

function* getStateFromApi() {
  yield takeLatest(FRUITS.GET_STATE_FROM_API, function* (action) {
    const response = yield apiRequest('api/v1/fruits', { method: 'get' });
    yield put(apiSuccess(FRUITS.GET_STATE_FROM_API_SUCCESS, response));
  });
}

function* createFruit() {
  yield takeLatest(FRUITS.CREATE_FRUIT, function* (action) {
    yield put(appActions.setLoader('create-edit-fruit', true));
    const response = yield apiRequest('api/v1/fruits', {
      method: 'post',
      body: JSON.stringify(action.controls),
    });
    if (truthty(response.error)) {
      yield put(appActions.setError(response.errorMsg));
    } else {
      yield put(apiSuccess(FRUITS.CREATE_FRUIT_SUCCESS, response));
    }
    yield put(appActions.setLoader('create-edit-fruit', false));
  });
}

function* editFruit() {
  yield takeLatest(FRUITS.EDIT_FRUIT, function* (action) {
    yield put(appActions.setLoader('create-edit-fruit', true));
    const response = yield apiRequest(`api/v1/fruits/${action.id}`, {
      method: 'put',
      body: JSON.stringify(action.controls),
    });
    if (truthty(response.error)) {
      yield put(appActions.setError(response.errorMsg));
    } else {
      yield put(apiSuccess(FRUITS.EDIT_FRUIT_SUCCESS, response));
    }
    yield put(appActions.setLoader('create-edit-fruit', false));
  });
}

function* deleteFruit() {
  yield takeLatest(FRUITS.DELETE_FRUIT, function* (action) {
    yield put(appActions.setLoader('delete-fruit', true));
    const response = yield apiRequest(`api/v1/fruits/${action.id}`, { method: 'delete' });
    if (truthty(response.error)) {
      yield put(appActions.setError(response.errorMsg));
    }
    const item = Object.values(response)[0];
    yield put(apiSuccess(FRUITS.DELETE_FRUIT_SUCCESS, { item, type: 'fruits' }));
    yield put(appActions.setLoader('delete-fruit', false));
  });
}

function* exportFruits() {
  yield takeLatest(FRUITS.EXPORT_FRUIT, function* (action) {
    yield put(appActions.setLoader('export-fruits', true));
    const response = yield apiRequest(
      'api/v1/fruits/export',
      { method: 'get' },
      false,
      'fruits.xlsx',
    );
    yield put(apiSuccess(FRUITS.EXPORT_FRUIT_SUCCESS, response));
    yield put(appActions.setLoader('export-fruits', false));
  });
}

export default function* saga() {
  yield spawn(getStateFromApi);
  yield spawn(deleteFruit);
  yield spawn(createFruit);
  yield spawn(editFruit);
  yield spawn(exportFruits);
}
